// removed by extract-text-webpack-plugin
module.exports = {"header":"b7_bg","transparentHeader":"b7_b8 b7_bg","search":"b7_be","container":"b7_g","logo":"b7_v","menu":"b7_b9"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/Header/styles.module.css
// module id = 1120
// module chunks = 27